// @ts-ignore
import Properties from 'properties';

import * as _ from 'lodash';
import {
  USER_ADDITIONAL_CONFIGURATION_TYPE,
  USER_CONFIGURATION_TYPE
} from './Types';

class ConfigurationCls {
  private static _instance: ConfigurationCls = null;
  public apiMatch: RegExp = /^((http[s]?|ftp):\/)?\/?([^:\/\s]+)(?::([0-9]+))?((\/\w+)*\/?)?([\w\-\.]*[^#?\s]+)?(.*)?(#[\w\-]+)?$/;
  public pathMatch: RegExp = /\/?(.*[^\/])?\/?(webApi\/v[0-9])\/?(.*)/;
  private baseRouteNameRegex: RegExp;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  private static cfg: any = null;

  private constructor() {
    this.initialize();
  }

  public initialize() {
    const { USER_CONFIGURATION = {}, USER_ADDITIONAL_CONFIGURATION = {} } = window;
    // USER_CONFIGURATION - object created from data passed directly to index.jsp page
    // USER_ADDITIONAL_CONFIGURATION - object created by server and injected with <script> tag

    let result: USER_ADDITIONAL_CONFIGURATION_TYPE = USER_ADDITIONAL_CONFIGURATION || {};
    if (USER_CONFIGURATION) {
      const { API_URL, BASE_URL }: USER_CONFIGURATION_TYPE = USER_CONFIGURATION;

      if (API_URL) {
        let [full_url, raw_protocol, protocol, domain, port, path] = API_URL.match(this.apiMatch) || [];
        let [full_path, name, apiPrefix, restOfPath] = path.match(this.pathMatch) || [];
        result.REST_SERVER = {
          PROTOCOL: protocol,
          DOMAIN: domain,
          PORT: port,
          NAME: name,
          REST_API_PREFIX: apiPrefix
        };
      }

      if (BASE_URL) {
        result.BASE_URL = BASE_URL;
      }
    }

    this.set(result);
  }

  public get(item: string = undefined) {
    return item ? ConfigurationCls.cfg[item] : ConfigurationCls.cfg;
  }

  public getPathToStaticFolder(): string {
    const BASE_ROUTE_NAME = ConfigurationCls.cfg.BASE_ROUTE_NAME;
    return BASE_ROUTE_NAME === '/' ? '/static/' : `${BASE_ROUTE_NAME}/static/`;
  }

  /**
   * Returns pure path name.
   * E.g. If route is `/login` when BASE_ROUTE_NAME is '/' then `/login` will be returned.
   * If route is `/APP/login` when BASE_ROUTE_NAME is '/APP' then `/login` will be returned.
   */
  public getPathname() {
    return '/' + document.location.pathname.replace(this.baseRouteNameRegex, '');
  }

  private set(serverData: any = {}) {
    const {
      I18N_HASH,
      APP_LANDING_URL,
      APP_LOGIN_TYPE,
      AUTH_GLOBAL_LOGOUT,
      AUTH = {},
      BASE_URL,
      COOKIES = {},
      CONSENT = {},
      REMOTE_LOG_URL,
      REST_SERVER = {},
      APP_SETTINGS,
      SESSION_TIMEOUT = 20, // defaults to 20 minutes
      SESSION_COUNTDOWN = 20, // defaults to 20 seconds
      WEB_SOCKET = {},
      FEATURE_AWARE = {}
    } = Properties;
    let { BASE_ROUTE_NAME = '' } = Properties;
    BASE_ROUTE_NAME.trim();
    if (BASE_ROUTE_NAME.startsWith('/')) {
      // if base route name starts with /, than remove it
      BASE_ROUTE_NAME = BASE_ROUTE_NAME.replace(/^\//, '');
    }
    BASE_ROUTE_NAME = BASE_ROUTE_NAME.length ? `/${BASE_ROUTE_NAME}` : '/';
    const {
      authorization,
      authority,
      change_password_uri,
      client_id,
      response_type,
      scope
    } = AUTH;

    const {
      REST_API_PREFIX,
      PROTOCOL,
      DOMAIN,
      NAME,
      PORT,
      REQUEST_TIMEOUT = 10 // defaults to 10 seconds
    } = REST_SERVER;

    ConfigurationCls.cfg = _.merge({
      I18N_HASH,
      APP_LANDING_URL,
      APP_LOGIN_TYPE,
      AUTH_GLOBAL_LOGOUT,
      AUTH: {
        authorization,
        authority,
        change_password_uri,
        client_id,
        response_type,
        scope
      },
      BASE_URL: BASE_URL,
      BASE_ROUTE_NAME,
      COOKIES,
      CONSENT,
      REMOTE_LOG_URL: REMOTE_LOG_URL || null,
      REST_SERVER: {
        REST_API_PREFIX: REST_API_PREFIX || '',
        PROTOCOL,
        DOMAIN,
        NAME,
        PORT: PORT || null,
        REQUEST_TIMEOUT: REQUEST_TIMEOUT
      },
      WEB_SOCKET,
      FEATURE_AWARE,
      APP_SETTINGS,
      SESSION_TIMEOUT: SESSION_TIMEOUT,
      SESSION_COUNTDOWN: SESSION_COUNTDOWN
    }, serverData);

    this.baseRouteNameRegex = new RegExp('^' + BASE_ROUTE_NAME + (BASE_ROUTE_NAME.length > 1 ? '/' : ''), 'g');
  }

  // <debug>
  /**
   * Test helper fn to override cfg
   * @param cfg
   */
  public testHelper_set(cfg: any = {}) {
    this.set(cfg);
  }

  // </debug>

  // private async getServerConfiguration(API_URL: string) {
  //   let [full_url, protocol, domain, port, path] = API_URL.match(/(.+):\/\/(.+):(\d+)\/(.+)/);
  //   const axiosInstance = axios.create(getApiConfig(protocol, domain, port, path, REQUEST_TIMEOUT));
  //   const result = await axiosInstance.get('configuration');
  //   return result.data;
  // }
}

const Configuration = ConfigurationCls.Instance;
// <debug>
if (!_.get(window, 'Configuration')) {
  _.set(window, 'Configuration', Configuration);
}
// </debug>
export default Configuration;
